import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate  } from "react-router-dom";
// import Home from "./pages/Home/Home";
import Dashboard from "./pages/Dashboard/Dashboard";
import PasswordHash from "./components/PasswordHash/PasswordHash";
import Profile from "./pages/Profile";
import Tutorial from "./pages/Tutorial";
import Home from "./pages/Home/Home";
import News from "./pages/News/News";
import FAQ from "./pages/FAQ/FAQ";

import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import { UserProvider } from "./contexts/UserContext";
import { PIPELINE_CONFIG } from "./config/pipelineConfig";

function App() {


  const firstDashboardPath = PIPELINE_CONFIG[0]?.path || "/dashboard/cro";
  
  // const dashboardRoutes = getDashboardRoutes();

  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />


          <Route path="/dashboard" element={<Navigate to={firstDashboardPath} replace /> } />
          <Route path="/dashboard/:subpage" element={<Dashboard /> } />
          <Route path="/tutorial" element={<Tutorial />} />
          <Route path="/news" element={<News />} />
          <Route path="/faq" element={<FAQ />} />


          {/* Protected routes */}
          <Route path="/profile" element={ <ProtectedRoute> <Profile /> </ProtectedRoute>} />
          <Route path="/password-hash" element={<ProtectedRoute> <PasswordHash /> </ProtectedRoute>} />

        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
